import React from "react";
//bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500
const Navbar = () => (
    <nav class="flex items-center justify-between object-cover flex-wrap bg-gray-900 p-3">
    <div class="flex items-center flex-shrink-0 text-white mr-10">
      
      <span class="font-semibold text-xl tracking-tight font-mono">DirtyCode</span>
    </div>
    
    <div class="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
      <div class="text-sm lg:flex-grow">


        <a href="#responsive-header" class=" block mt-4 lg:inline-block lg:mt-0 text-lime-50 hover:text-black mr-4">
          About
        </a>


        <a href="#responsive-header" class="block mt-4 lg:inline-block lg:mt-0 text-lime-50 hover:text-black mr-4">
          Statistics
        </a>


        <a href="#responsive-header" class="block mt-4 lg:inline-block lg:mt-0 text-lime-50 hover:text-black">
          Contact Us
        </a>


      </div>
      <div>
        <a href="#" class="inline-block text-xs px-4 py-2 leading-none border rounded text-white border-transparent bg-gray-700 
        hover:border-transparent hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700  mt-4 lg:mt-0">Pages Help</a>
      </div>
    </div>
  </nav>
);

export default Navbar;
